export const PASSWORD_MATCH_INVALID = "Your password and confirmation password do not match.";
